// German for the PEOPLE zone: contacts on the record and the ghosts the evidence names.
import { registerDe } from '../i18n/index.js';

registerDe({
  'People': 'Personen',
  '{name} is on the record — open the client record to give them a role.': '{name} ist im Protokoll — öffnen Sie den Kundendatensatz, um eine Rolle zu vergeben.',
  '{n} on record': '{n} erfasst',
  '{n} named by the evidence only': '{n} nur in den Belegen genannt',
  'Contacts & record': 'Kontakte & Datensatz',
  'No contact on file, and no person named on any event. G0 cannot pass on any engagement until a contact is named for it.': 'Kein Kontakt erfasst und keine Person auf einem Ereignis genannt. G0 kann für keinen Auftrag bestehen, bis ein Kontakt dafür benannt ist.',
  'sponsor': 'Sponsor',
  'Named sponsor for {code} — the answer G0 checks': 'Benannter Sponsor für {code} — die Antwort, die G0 prüft',
  'no role on file': 'keine Rolle erfasst',
  'no email': 'keine E-Mail',
  'not on the record': 'nicht im Protokoll',
  'named on {n} event': 'auf {n} Ereignis genannt',
  'named on {n} events': 'auf {n} Ereignissen genannt',
  'no email on the event': 'keine E-Mail auf dem Ereignis',
  'Create a contact from this evidence — the role can be filled in on the record': 'Aus diesem Beleg einen Kontakt anlegen — die Rolle kann im Datensatz ergänzt werden',
  'Promoting…': 'Wird angelegt…',
  'Promote to contact': 'Zum Kontakt machen',
}, 'ClientPeople');
